import React, { useEffect } from 'react'
import { PropTypes } from 'prop-types'
import useScript from '../../hooks/useScript'
import { WorkableContainer } from './Workable.styles'

export default function Workable({ title, workableID, anchorTag }) {
	const [loaded, error] = useScript('https://www.workable.com/assets/embed.js')

	useEffect(() => {
		if (loaded) {
			// Load the embedded Workable Code
			/* eslint-disable no-undef, react/no-this-in-sfc */
			whr(document).ready(function () {
				whr_embed(workableID, { detail: 'titles', base: 'jobs', zoom: 'country', grouping: 'departments' })
				whr(document).on('click', 'li.whr-item a', function (e) {
					e.preventDefault()
					window.open(this.href, '_blank', 'noopener,noreferrer')
				})
			})
			/* eslint-enable no-undef, react/no-this-in-sfc */
		}
	}, [loaded, workableID])

	return (
		!error && (
			<WorkableContainer id={anchorTag}>
				{title && <h2>{title}</h2>}
				<div id="whr_embed_hook" />
			</WorkableContainer>
		)
	)
}

Workable.propTypes = {
	title: PropTypes.string,
	workableID: PropTypes.string,
	anchorTag: PropTypes.string,
}
